import {Component, Inject, OnInit,} from '@angular/core';

import {ActivatedRoute, Router} from '@angular/router';

import {
  AlertService,
  AuthenticationService,
  ClientProfileService,
  ControlItemsService,
  TenantService,
  UserService,
} from '../../_services/index';

import {Tenant} from '../../_models/index';

import {MatDialog, MatDialogConfig} from "@angular/material/dialog";


import {LoginHelper, Role} from '../../helpers';
import {DOCUMENT} from "@angular/common";
import {FormBuilder} from "@angular/forms";
import {AssessmentService} from "../../_services/assessment.service";
import {Constants} from "../../helpers/constants";
import {AskStringComponent} from "../askString/askString.component";
import {SarProfileService} from "../../_services/sarProfile.service";
import {SapProfileService} from "../../_services/sapProfile.service";
import {saveAs as importedSaveAs} from "file-saver";

const defaultDialogConfig = new MatDialogConfig();

@Component({
    standalone: false,
  selector: "assessments-component",
  templateUrl: 'assessments.component.html',
  styleUrls: ['./assessments.component.scss'],
})

export class AssessmentsComponent implements OnInit {
  pageTitle;
  collapsed: boolean = false;
  api = window.location.origin;
  items: any[];
  assessments = [];
  canEdit: boolean = false;
  tenantName: string;
  canCreateAssesment: boolean = false;
  tenant: Tenant;
  isSurvey: boolean;
  isRealUser: boolean;
  isInviteVisible: boolean = false;
  rowGroupMetadata: {};
  constants = Constants;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public alertService: AlertService,
    public authenticationService: AuthenticationService,
    public userService: UserService,
    public dialog: MatDialog,
    @Inject(DOCUMENT) public document: any,
    public _formBuilder: FormBuilder,
    public controlItemsService: ControlItemsService,
    public tenantService: TenantService,
    public clientProfileService: ClientProfileService,
    public assessmentService: AssessmentService) {
    this.assessmentService.updateList.subscribe(i => this.loadAssessments());
    const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    this.isInviteVisible = (currentUser.role & (Role.Manager | Role.PrimaryManager)) != 0
      || (currentUser.role & Role.KingAdmin) != 0
      || (currentUser.role & (Role.AdvisorLead | Role.PrimaryAdvisorLead | Role.PlatformSupport)) != 0;
    this.clientProfileService.getPublicSettings(LoginHelper.getTenantName()).subscribe(s => this.pageTitle = s.menuLabels['Forms'] || 'Surveys');
  }


  copyAssessment(assessment) {
    const quiz = JSON.parse(JSON.stringify(assessment));
    quiz.quizData.name = "Copy of " + quiz.quizData.name;
    quiz.quiz = JSON.stringify(quiz.quizData);
    quiz.id = 0;
    this.assessmentService.saveAssessment(quiz).subscribe(p => {
        this.router.navigate(['/assessments/assessment', p.id]);
        this.loadAssessments();
      }
    );
  }

  ngOnInit() {
    this.tenantName = LoginHelper.getTenantName();
    const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    this.canEdit = (currentUser.role & (Role.AdvisorLead | Role.PrimaryAdvisorLead | Role.PlatformSupport)) != 0 ||
      (currentUser.role & (Role.Manager | Role.PrimaryManager)) != 0 ||
      (currentUser.role & Role.KingAdmin) != 0 ||
      (currentUser.role & Role.Admin) != 0;
    this.isSurvey = (currentUser.role & Role.Survey) != 0;
    this.isRealUser = (currentUser.role & (Role.Survey | Role.Training | Role.Vendor)) === 0;
    this.tenantService.getCurrent().subscribe(p => {
      this.tenant = p;
      this.loadAssessments();
    });

  }

  loadAssessments() {
    const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    this.assessmentService.getAllAssessments().subscribe(t => {
      this.assessments = t.filter(i => this.canEdit || ((i.assessmentUsers || [])).find(u => u.userId == currentUser.userId));
      this.canCreateAssesment = (this.tenantName == Constants.RiskSpongeMaster || this.assessments.length < this.tenant.maxSurveys) && !this.isSurvey;
    });
  }

  uploadAssessment(event) {
    let attachments = event.target.files;
    if (attachments.length > 0) {
      let file: File = attachments[0];
      const reader = new FileReader();
      reader.addEventListener('load', (e) => {
        const quizData = JSON.parse((<any>(e.target)).result);
        if (this.assessments.find(a => a.quizData.name === quizData.QuizData.Name)) {
          this.askForName(file, '');
        } else {
          this.doUploadAssessment(file);
        }
      });
      reader.readAsText(file);
    }
  }

  askForName(file, name) {
    let config: MatDialogConfig = {
      width: "auto",
      height: "auto",
      data: {
        initialValue: name,
        title: "Duplicate Name - please enter another one"
      }
    };

    let dialogRef = this.dialog.open(AskStringComponent, config);

    dialogRef.afterClosed().subscribe((result: string) => {
      if (result) {
        if (this.assessments.find(a => a.quizData.name === result)) {
          this.askForName(file, result);
        } else {
          this.doUploadAssessment(file, result);
        }
      }
    });
  }

  doUploadAssessment(file, name = null) {
    this.assessmentService.importAssessment(file, name)
      .subscribe((res) => {
          this.loadAssessments();
        },
        (error) => {
          const errorMessage = 'An error occurred while importing assessment.';
          this.alertService.error(errorMessage);
        });
  }

  deleteAssessmentAnswer(answer) {
    this.assessmentService.deleteAssessmentAnswer(answer.id).subscribe(() => this.ngOnInit());
  }
}
